export enum AppPages {
  AuthCallback = "auth-callback",
  AuthError = "auth-error",
  Default = "default",
  Login = "login",
  Logout = "logout",
  Onboarding = "onboarding",
  OnboardingAgreementSigning = "onboarding-agreement-signing",
  OnboardingBusinessDetails = "onboarding-business-details",
  OnboardingBusinessOwners = "onboarding-business-owners",
  OnboardingStatusApproved = "onboarding-status-approved",
  OnboardingStatusInReview = "onboarding-status-in-review",
  OnboardingStatusRejected = "onboarding-status-rejected",
  RedirectToProduct = "redirect-to-product",
  Signup = "signup",
}
